import { createSlice } from '@reduxjs/toolkit';
import { getAllYoutubeVideos } from '../api/youtubeVideos';

export const youtubeVideoSlice = createSlice({
  name: 'youtube',
  initialState: {
    loading: false,
    error: {},
    youtubeVideos: {},
  },
  reducers: {
    clearYoutubeError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [getAllYoutubeVideos.pending]: (state) => {
      state.loading = true;
    },
    [getAllYoutubeVideos.fulfilled]: (state, action) => {
      state.loading = false;
      state.youtubeVideos = action.payload;
      state.error = {};
    },
    [getAllYoutubeVideos.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearYoutubeError } = youtubeVideoSlice.actions;

export default youtubeVideoSlice.reducer;
